import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Slider from '@vueform/slider'
import { onMounted, ref } from 'vue'

import { SliderRange } from './Slider'

type SliderOptions = {
  range?: SliderRange
  connect?: 'lower' | 'upper' | boolean | boolean[]
}

type Props = {
  value: number
  low: number
  high: number
  hasTooltips?: boolean
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right'
  format?: (value: number) => string
  range?: SliderRange
}

type Emits = {
  (event: 'on-update', value: number): void
  (event: 'on-change', value: number): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Slider',
  props: {
    value: { default: 0 },
    low: {},
    high: {},
    hasTooltips: { type: Boolean, default: false },
    tooltipPosition: { default: undefined },
    format: { type: Function, default: undefined },
    range: { default: () => ({ min: 0, max: 100 }) }
  },
  emits: ["on-update", "on-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const val = ref(props.value)
const options = ref<SliderOptions>({ range: props.range, connect: 'upper' })
const isTooltipDisplayed = ref(props.hasTooltips)

const update = (value: number) => {
  val.value = value
  emits('on-update', value)
}

const change = (value: number) => {
  val.value = value
  emits('on-change', value)
}

onMounted(() => {
  isTooltipDisplayed.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["slider", `${val.value < _ctx.low ? 'low' : ''} ${val.value > _ctx.high ? 'high' : ''}`])
  }, [
    _createVNode(_unref(Slider), {
      modelValue: val.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((val).value = $event)),
      options: options.value,
      tooltips: _ctx.hasTooltips,
      "show-tooltip": "drag",
      "tooltip-position": _ctx.tooltipPosition,
      format: _ctx.format,
      lazy: false,
      "data-testid": "slider",
      onUpdate: update,
      onChange: change
    }, null, 8 /* PROPS */, ["modelValue", "options", "tooltips", "tooltip-position", "format"])
  ], 2 /* CLASS */))
}
}

})